<script>
  import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';
  import { navigate } from 'svelte-routing';

  export let icon;
  export let text;
  export let href = '#';
  export let enabled = true;
  export let show = true;
  export let indent = false;
  export let onClick = null;
  export let rightIcon = null;
  export let counter = null;
  export let collapsed = false;
  export let hasSubmenu = false;

  function handleClick(event) {
    if (!enabled) {
      event.preventDefault();
      return;
    }
    if (onClick) {
      onClick(event);
    }
    // Client-side routing for plain left-click. Modifier-clicks (ctrl, cmd,
    // shift, middle-button) fall through to default <a> behaviour so devs
    // can still open in a new tab. Skip for the "#" / external href cases.
    if (
      href && href !== '#' && href.startsWith('/') &&
      event.button === 0 &&
      !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey &&
      !event.defaultPrevented
    ) {
      event.preventDefault();
      navigate(href);
    }
  }
</script>

{#if show}
<li
  class={collapsed 
    ? 'menu-item pl-4 pr-2 py-2 hover:bg-stone-200 dark:hover:bg-gray-500'
    : indent
      ? 'menu-item pl-8 pr-2 py-2 hover:bg-stone-200 dark:hover:bg-gray-500'
      : 'menu-item pl-4 pr-2 py-2 hover:bg-stone-200 dark:hover:bg-gray-500'}
>
  <a
    href={enabled && show ? href : '#'}
    class="flex items-center w-full"
    on:click={handleClick}
    title={collapsed ? text : ''}
  >
    <div
      class="icon {enabled && show
        ? 'text-sky-800 dark:text-sky-600'
        : 'text-sky-800/50 dark:text-gray-500'}"
    >
      <div class="icon-wrapper">
        <FontAwesomeIcon {icon} fixedWidth />
        {#if counter !== null && counter > 0}
          <span class="counter">{counter}</span>
        {/if}
        {#if collapsed && hasSubmenu}
          <span class="submenu-dot"></span>
        {/if}
      </div>
    </div>
    {#if !collapsed}
      <span
        class={enabled && show
          ? 'link text-sm text-gray-600 dark:text-slate-200'
          : 'link text-sm disabled-link text-gray-600 dark:text-slate-300'}
      >{text}</span>
      {#if rightIcon}
        <div class="right-icon {enabled && show ? 'text-gray-400' : 'text-gray-400/50'}">
          <FontAwesomeIcon icon={rightIcon} fixedWidth />
        </div>
      {/if}
    {/if}
  </a>
</li>
{/if}

<style>
  .disabled-link {
    pointer-events: none;
    opacity: 0.4;
    cursor: not-allowed;
  }

  .menu-item {
    display: flex;
    align-items: center;
    transition: background-color 0.3s;
  }

  .icon {
    margin-right: 8px;
  }

  .icon-wrapper {
    position: relative;
    display: inline-block;
  }

  .counter {
    position: absolute;
    top: -8px;
    right: -8px;
    min-width: 16px;
    height: 16px;
    padding: 0 4px;
    font-size: 10px;
    line-height: 16px;
    text-align: center;
    color: white;
    background-color: #e53e3e;
    border-radius: 8px;
    font-weight: 600;
  }

  .right-icon {
    margin-left: auto;
    width: 12px;
    font-size: 0.75rem;
  }

  .submenu-dot {
    position: absolute;
    top: 50%;
    right: -6px;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 3px solid transparent;
    border-bottom: 3px solid transparent;
    border-left: 4px solid currentColor;
  }

  .link {
    flex: 1;
  }
</style>
